import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { MarkdownBase, PageWrapper } from '@/components';
export const Help = () => {
    const { t } = useTranslation();
    return (_jsx(PageWrapper, Object.assign({ title: t('app:components.navigation.help_dialog_title') }, { children: _jsx(MarkdownBase, { markdown: t('app:components.navigation.help_dialog_body') }) })));
};
